import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Sidebar from "../../../components/Nip/Sidebar";
import Calendar from "../../../assets/assets/calendar_today-24px.svg";
import Spinner from "react-spinner-material";
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import Modal from "./Modal";
import { PropTypes } from "prop-types";
import { NipNavbar } from "../../../components/Nip/Navbar";
import Review from "./Review";
import MigrationCalendar from "./Calendar";
import Slots from "./Slots";
import {
  assignValues,
  confirmSection,
  handleCalendar,
  handleSelection,
  mapDispatchToProps,
} from "./functions";

const Migration = (props) => {
  const {
    getSlots,
    isGettingMigrationSlots,
    migrationSlots,
    isBookingSlot,
    bookingSlotSuccess,
    chooseSlot,
    clearState,
    getMonths,
    migrationMonths,
    getDays,
    migrationDays,
    isGettingMigrationDays,
    isGettingMigrationMonths,
  } = props;

  const history = useHistory();
  const appId = props.location.state && props.location.state.id;
  const type = "nip";

  const [state, setState] = useState({
    start_time: "",
    end_time: "",
    slot: "",
    month: "",
    date: "",
    active: false,
    index: "",
    show: false,
  });

  const [modal, setModal] = useState({
    visible: false,
  });

  useEffect(
    () => {
      clearState();
      getMonths();
    },
    // eslint-disable-next-line
    [clearState, getMonths]
  );

  const cancel = () => {
    setState({
      ...state,
      show: false,
    });
  };

  const hide = () => {
    setModal({ ...modal, visible: false });
    history.push({
      pathname: `/nip/integration/${appId}`,
      state: {
        id: appId,
      },
    });
  };

  const found =
    migrationDays && migrationDays.some((el) => el.day === Number(state.date));

  const handleChange2 = handleCalendar(
    setState,
    state,
    getDays,
    found,
    getSlots,
    "nip"
  );

  const handleChange = handleSelection(setState, state, getSlots, "nip");

  const btnValue = (index, start, end, slot) => {
    setState({
      ...state,
      active: true,
      index: index,
      start_time: start,
      slot: slot,
      end_time: end,
    });
  };

  const bookSlot = assignValues(appId, state, type, chooseSlot);

  useEffect(
    () => {
      if (bookingSlotSuccess) {
        setModal({ ...modal, visible: true });
      }
    },
    // eslint-disable-next-line
    [bookingSlotSuccess]
  );

  const disableButton =
    state.start_time === "" ||
    state.date === "" ||
    state.end_time === "" ||
    state.month === "";

  const openConfirm = confirmSection(state, setState);

  return (
    <div className="container">
      <NipNavbar />
      <Sidebar />

      <div className="container-body7">
        <div className="demo-header">
          <div className="image">
            <img src={Calendar} alt="icon" />
          </div>
          <h3>Schedule Migration</h3>
        </div>
        {state.show ? (
          <Review
            type={type}
            state={state}
            disableButton={disableButton}
            cancel={cancel}
            isBookingSlot={isBookingSlot}
            bookSlot={bookSlot}
            text={"Migration"}
          />
        ) : (
          <div>
            {isGettingMigrationMonths ? (
              <div className="demo-calendar">
                <Spinner
                  size={120}
                  color={"#047558"}
                  spinnerwidth={5}
                  visible={true}
                />
              </div>
            ) : (
              <MigrationCalendar
                state={state}
                migrationMonths={migrationMonths}
                migrationDays={migrationDays}
                isGettingMigrationDays={isGettingMigrationDays}
                handleChange2={handleChange2}
                found={found}
                handleChange={handleChange}
              />
            )}

            {isGettingMigrationSlots ? (
              <div className="center-spinner2">
                <Spinner
                  size={120}
                  color={"#047558"}
                  spinnerwidth={5}
                  visible={true}
                />
              </div>
            ) : (
              <Slots
                state={state}
                migrationDays={migrationDays}
                migrationSlots={migrationSlots}
                btnValue={btnValue}
                found={found}
              />
            )}
            {migrationSlots && migrationSlots.length > 0 ? (
              <div className="proceed-btn-div">
                <button
                  className="proceed-btn"
                  disabled={disableButton}
                  onClick={openConfirm}
                >
                  Book Slot
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
        <Rodal
          width={Number("550")}
          height={Number("500")}
          visible={modal.visible}
        >
          <Modal click={hide} />
        </Rodal>
      </div>
    </div>
  );
};

const mapStateToProps = stateToProps();
propTypes();

export default connect(mapStateToProps, mapDispatchToProps)(Migration);

function propTypes() {
  Migration.propTypes = {
    migrationSlots: PropTypes.array,
    bookingSlotSuccess: PropTypes.bool,
    chooseSlot: PropTypes.func,
    clearState: PropTypes.func,
    migrationDays: PropTypes.array,
    migrationMonths: PropTypes.array,
    getDays: PropTypes.func,
    getMonths: PropTypes.func,
    getSlots: PropTypes.func,
    isBookingSlot: PropTypes.bool,
    isGettingMigrationDays: PropTypes.bool,
    isGettingMigrationMonths: PropTypes.bool,
    isGettingMigrationSlots: PropTypes.bool,
    location: PropTypes.shape({
      state: PropTypes.shape({
        id: PropTypes.number,
        type: PropTypes.string,
      }),
    }),
  };
}

function stateToProps() {
  return (state) => {
    return {
      isGettingMigrationSlots: state.demo.isGettingDemoSlots,
      migrationSlots: state.demo.DemoSlots,
      getMigrationSlotsSuccess: state.demo.getDemoSlotsSuccess,
      isGettingMigrationMonths: state.demo.isGettingDemoMonths,
      migrationMonths: state.demo.demoMonths,
      getMigrationMonthsSuccess: state.demo.getDemoMonthsSuccess,
      isGettingMigrationDays: state.demo.isGettingDemoDays,
      migrationDays: state.demo.demoDays,
      getMigrationDaysSuccess: state.demo.getDemoDaysSuccess,
      isBookingSlot: state.demo.isBookingSlot,
      bookingSlotSuccess: state.demo.bookingSlotSuccess,
    };
  };
}
